/**
 * Enumeration for the OptiDrive event state.
 *
 * @readonly
 * @enum {string}
 */
export const OptiDriveEventState = Object.freeze({
    EXCLUDED: 'EXCLUDED',
    RECOVERED: 'RECOVERED'
})
